export default __webpack_public_path__ + "static/media/Helm of the Painlegion.a21af1a9.jpg";